import React from 'react'
import { Container } from './style'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { VaccinationType } from '../../../../types';

const VaccinationInfo = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);
  return (
    <Container>
      <ul>
        {selectedClient?.vaccinations?.map((vaccination: VaccinationType) => (
          <li>
            {vaccination?.vaccination?.name}{' '}
            <span>•</span>
            {vaccination?.when}{' '}
            <span>•</span>
            {vaccination?.physiologicalResponse}
          </li>
        ))}
      </ul>
    </Container>
  )
}

export default VaccinationInfo